import { Suspense, useEffect, useLayoutEffect, useState } from 'react'
import { Canvas, dispose } from '@react-three/fiber'
import { useGLTF, Environment, Stage, OrbitControls, Html } from '@react-three/drei'
import create from 'zustand'
import styles from "./styles.module.css"
import loaderStyles from "./loader.module.css"
import { HexColorPicker } from "react-colorful"
import * as THREE from 'three';
import axios from 'axios';
import { custom_model_Data } from './ModelsData'
import * as FaIcons from 'react-icons/fa'
import * as AiIcons from 'react-icons/ai'



let store = (set) => ({
    selectedMesh: "TAPE_1",
    lidColor: '#ffffff',
    targetMaterial: "",
    targetSky: "apartment",
    mobileView: true,
    setSelectedMesh: (mesh_name) => set((state) => ({ selectedMesh: mesh_name })),
    setLidColor: (color) => set((state) => ({ lidColor: color })),
    setTargetMaterial: (material_name) => set((state) => ({ targetMaterial: material_name })),
    setTargetSky: (sky_name) => set((state) => ({ targetSky: sky_name })),
    setMobileView: (viewType) => set((state) => ({ mobileView: viewType })),
})

const useStore = create(store);

let modelInfo = (set) => ({
    //modelUrl: `https://api.app3.ogmo.xyz/designs/shortid/r89pT8r-X0ry0`,//bottle
    modelUrl: `https://api.app3.ogmo.xyz/designs/shortid/z9E-Xtb1QfGOD`,//ball
    //modelUrl: `https://api.app3.ogmo.xyz/designs/shortid/awXIwuxM-1FZy`,//bottle two
    modelPath: "",
    materials: "",
    meshes: "",
    nodes: "",
    selectedMesh: "TOP_1",
    materialSelection: false,
    bothItem: false,
    setModelUrl: (model_url) => set((state) => ({ modelUrl: model_url })),
    setModelPath: (model_path) => set((state) => ({ modelPath: model_path })),
    setMaterials: (model_Mat) => set((state) => ({ materials: model_Mat })),
    setMeshes: (model_mesh) => set((state) => ({ meshes: model_mesh })),
    setNodes: (model_node) => set((state) => ({ nodes: model_node })),
    setSelectedMesh: (selected_Mesh) => set((state) => ({ selectedMesh: selected_Mesh })),
    setMaterialSelection: (selection) => set((state) => ({ materialSelection: selection })),
    setBothItem: (both) => set((state) => ({ bothItem: both }))
})

const useModel = create(modelInfo);

function GetModel() {
    const model_url = useModel((state) => state.modelUrl);
    const setModelPath = useModel((state) => state.setModelPath);
    const setMeshes = useModel((state) => state.setMeshes);
    const setMaterialSelection = useModel((state) => state.setMaterialSelection);
    const setMaterials = useModel((state) => state.setMaterials);
    const customModelData = custom_model_Data;
    useEffect(() => {
        axios.get(model_url)
            .then(res => {
                const Data = res.data;
                customModelData.map((data, key) => {
                    if (data.designId === Data.data.designId) {
                        setMeshes(data.meshes);
                        setMaterialSelection(data.materialSelection)
                        setMaterials(data.materials)
                    }
                }
                )
                //console.log("DesiginID:" + Data.data.designId)
                setModelPath(Data.data.sceneInfo.modelPath);
            })
    }, [])

    return (<></>)
}

function Picker() {
    const mobileView = useStore((state) => state.mobileView);
    const [colorcode1, setColorCode1] = useState("#ffffff");
    const [colorcode2, setColorCode2] = useState("#ffffff");
    const [colorcode3, setColorCode3] = useState("#ffffff");
    const [picker, setpicker] = useState(false);
    const bothItem = useModel((state) => state.bothItem);
    const setbothItem = useModel((state) => state.setBothItem);
    const setSelected_mesh = useModel((state) => state.setSelectedMesh);
    const setTargetMaterial = useStore((state) => state.setTargetMaterial)
    const setLidColor = useStore((state) => state.setLidColor)
    const materialSelection = useModel((state) => state.materialSelection);
    const materials = useModel((state) => state.materials);

    const handleChange = () => {
        setbothItem(!bothItem);
    };

    return (
        <>{mobileView ? (
            <>{picker ? (
                <div className={styles.OptionPanel}>
                    {<AiIcons.AiOutlineClose className={styles.closeIcon} onClick={() => { setpicker(false) }} />}
                    <div className={styles.checkBox}>
                        <label>
                            <input
                                type="checkbox"
                                checked={bothItem}
                                onChange={handleChange}
                            />
                            <b className={styles.checkBoxText}>Match Top and Jar </b>
                        </label>
                    </div>
                    <h5 className={styles.textAlign}>Change Color on {bothItem ? ('both') : ('Top')}</h5>
                    <div className={styles.colorPaletParent}>
                        <HexColorPicker className={styles.picker} color={'#ffffff'} onChange={(color) => { setSelected_mesh("TOP_1"); setLidColor(color); setColorCode1(color); bothItem && setColorCode2(color); }} />
                        <div className={styles.colorCode}>Selected color : {colorcode1}</div>
                    </div>
                    {!bothItem && <div><h5 className={styles.textAlign}>Change Color on Jar</h5>
                        <div className={styles.colorPaletParent}>
                            <HexColorPicker className={styles.picker} color={'#ffffff'} onChange={(color) => { setSelected_mesh("BASE_1"); setLidColor(color); setColorCode2(color) }} />
                            <div className={styles.colorCode}>Selected color :{colorcode2}</div>
                        </div></div>}
                    <h5 className={styles.textAlign}>Change Color on Tape</h5>
                    <div className={styles.colorPaletParent}>
                        <HexColorPicker className={styles.picker} color={'#ffffff'} onChange={(color) => { setSelected_mesh("TAPE_1"); setLidColor(color); setColorCode3(color) }} />
                        <div className={styles.colorCode}>Selected color :{colorcode3}</div>
                    </div>
                    {materialSelection && <div>
                        <h5 className={styles.textAlign}>Change Material on Tape</h5>
                        <div className={styles.ImagePanel}>
                            {materials !== "" &&
                                materials.map((data, key) => {
                                    return (
                                        <input key={key} className={styles.img} type="image" alt="image" src={data.imageLink} onClick={() => { setLidColor('#ffffff'); setSelected_mesh("TAPE_1");; setTargetMaterial(data.name) }} />
                                    )
                                })
                            }
                        </div>
                    </div>}

                </div>) : (
                <div className={styles.OptionPanel}> <FaIcons.FaBars className={styles.menuIcon} onClick={() => { setpicker(true) }} /></div>

            )}</>
        ) : (
            <div className={styles.OptionPanel}>
                <div className={styles.checkBox}>
                    <label>
                        <input
                            type="checkbox"
                            checked={bothItem}
                            onChange={handleChange}
                        />
                        <b className={styles.checkBoxText}>Match Top and Jar</b>
                    </label>
                </div>
                <h5 className={styles.textAlign}>Change Color on {bothItem ? ('both') : ('Top')}</h5>
                <div className={styles.colorPaletParent}>
                    <HexColorPicker className={styles.picker} color={'#ffffff'} onChange={(color) => { setSelected_mesh("TOP_1"); setLidColor(color); setColorCode1(color); bothItem && setColorCode2(color); }} />
                    <div className={styles.colorCode}>Selected color : {colorcode1}</div>
                </div>
                {!bothItem && <div><h5 className={styles.textAlign}>Change Color on Jar</h5>
                    <div className={styles.colorPaletParent}>
                        <HexColorPicker className={styles.picker} color={'#ffffff'} onChange={(color) => { setSelected_mesh("BASE_1"); setLidColor(color); setColorCode2(color) }} />
                        <div className={styles.colorCode}>Selected color : {colorcode2}</div>
                    </div></div>}
                <h5 className={styles.textAlign}>Change Color on Tape</h5>
                <div className={styles.colorPaletParent}>
                    <HexColorPicker className={styles.picker} color={'#ffffff'} onChange={(color) => { setSelected_mesh("TAPE_1"); setLidColor(color); setColorCode3(color) }} />
                    <div className={styles.colorCode}>Selected color : {colorcode3}</div>
                </div>
                {materialSelection && <div>
                    <h5 className={styles.textAlign}>Change Material on Tape</h5>
                    <div className={styles.ImagePanel}>
                        {materials !== "" &&
                            materials.map((data, key) => {
                                return (
                                    <input key={key} className={styles.img} type="image" alt="image" src={data.imageLink} onClick={() => { setLidColor('#ffffff'); setSelected_mesh("TAPE_1");; setTargetMaterial(data.name) }} />
                                )
                            })
                        }
                    </div>
                </div>}

            </div>)
        }
        </>

    )
}

function Model(props) {
    const model_path = useModel((state) => state.modelPath);
    const meshes = useModel((state) => state.meshes);
    const { scene, nodes, materials } = useGLTF(model_path);
    //console.log("Linked ModelData:");
    //console.log(useGLTF(useModel((state) => state.modelPath)));
    // A layout effect executes after the jsx has "rendered" but before it is committed to screen by the host (threejs)
    // This is a good place to make adjustments

    const targetMaterial = useStore((state) => state.targetMaterial)
    const selectedMesh = useStore((state) => state.selectedMesh)
    const lidColor = useStore((state) => state.lidColor)
    const selected_mesh = useModel((state) => state.selectedMesh);
    const setSelected_mesh = useModel((state) => state.setSelectedMesh);
    const bothItem = useModel((state) => state.bothItem);
    useLayoutEffect(() => {
        scene.traverse((obj) => obj.type === 'Mesh' && (obj.receiveShadow = obj.castShadow = true))
    }, [scene, nodes, materials])

    useLayoutEffect(() => {
        if (selectedMesh && targetMaterial) {
            nodes[selectedMesh].material = materials[targetMaterial]
            nodes[selectedMesh].material.color = new THREE.Color(lidColor);
        }
    }, [targetMaterial, selectedMesh])

    useLayoutEffect(() => {
        if (bothItem) {
            if (selected_mesh !== 'TAPE_1') {
                nodes['TOP_1'].material.color = new THREE.Color(lidColor);
                nodes['BASE_1'].material.color = new THREE.Color(lidColor);
            } else {
                nodes[selected_mesh].material.color = new THREE.Color(lidColor);
            }
        } else {
            meshes.map((data, key) => {
                if (data.mesh_name === selected_mesh && data.canChange) {
                    nodes[selected_mesh].material.color = new THREE.Color(lidColor);
                }
            }
            )
        }

    }, [lidColor])

    return (
        <group {...props}>
            <primitive object={nodes.root}  /*onClick={(event) => setSelected(!selected)}*/ />
        </group>
    )
}

function Env(props) {

    const targetSky = useStore((state) => state.targetSky)
    // files="hdr.hdr"
    return (
        <Environment files= 'Studio-09.hdr'/>
    )
}

export default function App() {

    const model_Path = useModel((state) => state.modelPath);
    const mobileView = useStore((state) => state.mobileView);
    const setMobileView = useStore((state) => state.setMobileView);

    useEffect(() => {
        const setResponsiveness = () => {
            return window.innerWidth < 771
                ? setMobileView(true)
                : setMobileView(false);
        };

        setResponsiveness();
        window.addEventListener("resize", () => setResponsiveness());

        return () => {
            window.removeEventListener("resize", () => setResponsiveness());
        }
    }, []);


    return (
        <div style={{ height: '100vh', width: '100vw' }}>
            <GetModel />
            <Picker />
            <Canvas style={{touchAction:"none"}} dpr={window.devicePixelRatio} shadows camera={{ fov: 45 }}>

                <color attach="background" args={['#f6f6f6']} />
                <fog attach="fog" args={['#f6f6f6', 10, 50]} />
                <Suspense fallback={<Html center><div className={loaderStyles.lds}><div></div><div></div></div></Html>}>
                    {/* <Stage> will center and light the contents, create ground-shadows, and zoom the camera */}
                    <Env />
                    <Stage adjustCamera environment={null} intensity={0.5} contactShadowOpacity={0.2} shadowBias={-0.0015} >
                        {model_Path !== '' && <Model scale={0.2} />}
                    </Stage>
                    <mesh rotation-x={-Math.PI / 2} position-y={-0.1} scale={100}>
                        {/**<planeGeometry /> */}
                        <meshStandardMaterial color="#ffffff" transparent depthWrite={false} />
                    </mesh>
                </Suspense>
                <>{mobileView ? (
                    <OrbitControls target={[0, 0.45, 0]} minDistance={3.5} maxDistance={6.5} autoRotate rotateSpeed={10} enableZoom={true} zoomSpeed={10} enablePan={true} maxPolarAngle={Math.PI / 2.1} /*minPolarAngle={Math.PI / 2.8} maxPolarAngle={Math.PI / 2.8}*/ />
                ) : (
                    <OrbitControls target={[0, 0.45, 0]} minDistance={3.5} maxDistance={6.5} autoRotate rotateSpeed={1} enableZoom={true} enablePan={true} maxPolarAngle={Math.PI / 2.1} /*minPolarAngle={Math.PI / 2.8} maxPolarAngle={Math.PI / 2.8}*/ />
                )}</>

            </Canvas>
        </div>
    )
}
